export default __webpack_public_path__ + "43d586d4daee87c86acdd83f580785c7.svg";